import { Alert, Snackbar } from '@mui/material';

import { useSnackbarStore } from '@/stores/useSnackbarStore';

export function GlobalSnackbar() {
  const open = useSnackbarStore((state) => state.isOpen);
  const options = useSnackbarStore((state) => state.options);
  const { closeSnackbar } = useSnackbarStore((state) => state.actions);

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={3000}
      onClose={closeSnackbar}
      open={open}
      sx={{ marginTop: 9 }}
    >
      <Alert onClose={closeSnackbar} severity={options?.color ?? 'info'} sx={{ width: '100%' }} variant="filled">
        {options?.title ? <b>{options.title}</b> : null}
        {options?.message ?? 'Erfolg'}
      </Alert>
    </Snackbar>
  );
}
